export { default as dateFnsLocales } from './dateFnsLocales';
